import { render, staticRenderFns } from "./AdminServiciosView.vue?vue&type=template&id=4848573b&"
import script from "./AdminServiciosView.vue?vue&type=script&lang=js&"
export * from "./AdminServiciosView.vue?vue&type=script&lang=js&"
import style0 from "./AdminServiciosView.vue?vue&type=style&index=0&id=4848573b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports